/* Falmouth Camp Moc page — gallery lightbox + press carousel */
(function () {
  'use strict';

  /* -------------------- Gallery lightbox -------------------- */
  function initGallery(gallery) {
    if (gallery.dataset.falGalInit) return;
    gallery.dataset.falGalInit = '1';
    var items = Array.prototype.slice.call(
      gallery.querySelectorAll('.fal-tile, .fal-gallery__item')
    );
    if (!items.length) return;

    var box = document.getElementById(gallery.dataset.lightbox);
    if (!box) return;

    var imgEl = box.querySelector('.fal-lightbox__img');
    var titleEl = box.querySelector('.fal-lightbox__caption-title');
    var textEl = box.querySelector('.fal-lightbox__caption-text');
    var countEl = box.querySelector('.fal-lightbox__count');
    var btnPrev = box.querySelector('.fal-lightbox__btn--prev');
    var btnNext = box.querySelector('.fal-lightbox__btn--next');
    var btnClose = box.querySelector('.fal-lightbox__close');
    var current = 0;
    var lastFocused = null;

    function render(i) {
      var item = items[i];
      var full = item.dataset.full || item.querySelector('img').src;
      var title = item.dataset.title || '';
      var desc = item.dataset.desc || '';
      imgEl.src = full;
      imgEl.alt = title || item.querySelector('img').alt || '';
      titleEl.textContent = title;
      titleEl.style.display = title ? '' : 'none';
      textEl.textContent = desc;
      textEl.style.display = desc ? '' : 'none';
      countEl.textContent = (i + 1) + ' / ' + items.length;
      current = i;
    }

    function open(i) {
      lastFocused = document.activeElement;
      render(i);
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      btnClose.focus();
    }

    function close() {
      box.hidden = true;
      document.body.style.overflow = '';
      imgEl.src = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function go(dir) {
      render((current + dir + items.length) % items.length);
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { open(i); });
    });
    if (btnPrev) btnPrev.addEventListener('click', function () { go(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { go(1); });
    if (btnClose) btnClose.addEventListener('click', close);

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('fal-lightbox__figure')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { go(-1); }
      else if (e.key === 'ArrowRight') { go(1); }
      else if (e.key === 'Tab') {
        /* Focus trap: keep keyboard focus inside the open dialog. */
        var f = box.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (box.contains(document.activeElement) === false) { e.preventDefault(); first.focus(); }
      }
    });

    /* Simple swipe on the image stage */
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      startX = null;
    });
  }

  /* -------------------- Press carousel -------------------- */
  function initCarousel(root) {
    if (root.dataset.falCarInit) return;
    root.dataset.falCarInit = '1';
    var track = root.querySelector('[data-fal-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fal-card]'));
    var prev = root.querySelector('[data-fal-prev]');
    var next = root.querySelector('[data-fal-next]');
    if (!track || cards.length === 0) return;

    var index = 0;
    var pvDesktop = parseInt(root.dataset.falPerviewDesktop, 10) || 4;
    var pvTablet = parseInt(root.dataset.falPerviewTablet, 10) || 2;
    var pvMobile = parseInt(root.dataset.falPerviewMobile, 10) || 1;

    function perView() {
      var w = window.innerWidth;
      if (w <= 749) return pvMobile;
      if (w <= 990) return pvTablet;
      return pvDesktop;
    }

    function maxIndex() {
      return Math.max(0, cards.length - perView());
    }

    function update() {
      if (index > maxIndex()) index = maxIndex();
      var card = cards[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '20') || 20;
      var step = card.getBoundingClientRect().width + gap;
      var pv = perView();
      track.style.transform = 'translateX(' + (-step * index) + 'px)';
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
      /* Keep off-screen slides out of the tab order & screen-reader tree
         (inert also removes them from AT in supporting browsers). */
      cards.forEach(function (c, i) {
        if (i >= index && i < index + pv) c.removeAttribute('inert');
        else c.setAttribute('inert', '');
      });
    }

    if (prev) prev.addEventListener('click', function () { index = Math.max(0, index - perView()); update(); });
    if (next) next.addEventListener('click', function () { index = Math.min(maxIndex(), index + perView()); update(); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 150);
    });

    /* swipe */
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) {
        if (dx < 0) index = Math.min(maxIndex(), index + 1);
        else index = Math.max(0, index - 1);
        update();
      }
      sx = null;
    });

    update();
  }

  function init() {
    document.querySelectorAll('.fal-gallery').forEach(initGallery);
    document.querySelectorAll('[data-fal-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
